import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Carousel, CarouselItem, Input, Loading, Menu, MenuItem, Option, Pagination, Select, Submenu, Table, TableColumn, TabPane, Tabs } from 'element-ui'
import i18n from "./langue/i18n"


Vue.config.productionTip = false
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Input)
Vue.use(Select)
Vue.use(Option)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(Pagination)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Loading)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

console.log('App env:', process.env.VUE_APP_ENV_NAME)
console.log('Bits API Base:', process.env.VUE_APP_BITS_API_BASE)
console.log('News API Base:', process.env.VUE_APP_NEWS_API_BASE)


// 提升 Element UI 全局 zIndex，确保所有弹层内联 z-index 基线为 7000+
Vue.prototype.$ELEMENT = { zIndex: 7000 }

